import React, { useState } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import AddAmenitiesAndHotelFacilitiesList from "./addAmenitiesAndFacilitiesList";

const AddAmenitiesAndHotelFacilitiesForm = (props) => {
  const [input, SetInput] = useState("");
  const [icon, SetIcon] = useState("");
  const handleSubmit = async () => {
    if (props.categoryType == "Amenities") {
      const newdata = {
        amenities: input,
        icon: icon,
      };
      const token = localStorage.getItem('token');
      const authHeader = `Bearer ${token}`;
      const res = await fetch("https://api.zupptravel.com/api/v1/hotel/addAmenities", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          'Authorization': authHeader
        },
        body: JSON.stringify(newdata),
      });
      const json = await res.json();

      if (json.success) {
        // alert("Added Hotel Amenities");
        alert("Added Hotel Amenities. Continue adding or refresh for fetching latest data");
        // window.location.reload();
      }
    } else {
      const token = localStorage.getItem('token');
      const authHeader = `Bearer ${token}`;
      const newdata = {
        facilities: input,
        icon: icon,
      };
      const res = await fetch("https://api.zupptravel.com/api/v1/hotel/addFacilities", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          'Authorization': authHeader
        },
        body: JSON.stringify(newdata),
      });
      const json = await res.json();
      console.log(json);
      if (json.success) {
        alert("Added Hotel Facility. Continue adding or refresh for fetching latest data");
        // window.location.reload();
      }
    }
  };
  return (
    <form>
      <Form.Group controlId="formBasicPromo" as={Row}>
        <Form.Label column sm="3">
          {props.categoryType}:
        </Form.Label>
        <Col sm="9">
          <Form.Control
            type="text"
            placeholder={`Enter ${props.categoryType}`}
            name="category"
            onChange={(e) => {
              SetInput(e.target.value);
            }}
            value={input}
            required
          />
        </Col>
      </Form.Group>
      <Form.Group controlId="formBasicIcon" as={Row}>
        <Form.Label column sm="3">
          Icon:
        </Form.Label>
        <Col sm="9">
          <Form.Control
            type="text"
            placeholder="Enter Icon"
            name="icon"
            onChange={(e) => {
              SetIcon(e.target.value);
            }}
            value={icon}
          />
        </Col>
      </Form.Group>
      <center>
        <Button style={{ margin: "2%" }} onClick={handleSubmit}>
          Save {`${props.categoryType}`}
        </Button>
      </center>
      <AddAmenitiesAndHotelFacilitiesList
        type={props.categoryType}
        data={props.data}
      />
    </form>
  );
};
export default AddAmenitiesAndHotelFacilitiesForm;
